<uxa-masthead>
  <div uxa-masthead-logo>
    <uxa-opentext-small-logo />
  </div>
  
  <div uxa-masthead-title>
    Threat Detection and Response
    <span uxa-masthead-title-secondary>MITRE ATT&CK Navigator</span>
    <span uxa-masthead-version>CE 25.2</span>
  </div>
</uxa-masthead>
<uxa-masthead-secondary>
  <a *ngFor="let item of items" uxa-masthead-tab routerLink="{{ item.routerLink }}" selected="{{ item.selected }}">{{ item.title }}</a>
  <uxa-toggle-switch *ngIf="isSwitchVisible" [(value)]="isEnabled" (valueChange)="toggleWindow()">
    Switch to OpenText Sentinel
  </uxa-toggle-switch>
</uxa-masthead-secondary>